import get from 'lodash.get'
import { Flow, UserDataValue } from '../api/models/types'
import getButtons from '../constants/buttons'

export default function computedValues(
  text: string,
  userData: Record<string, unknown> | UserDataValue,
  extra?: {}
) {
  /* Simplified */
  if (!text || typeof text !== 'string') return text
  const fullUserData = { ...userData, ...extra }
  return text.replace(/\{\{.+?\}\}/g, (key) => get(fullUserData, key.slice(2, -2), '') || '')
}

export function getDisplayValues(userData: { [key: string]: string } | UserDataValue, form: Flow) {
  const displayValues = { ...userData }
  const buttonComps = (form?.pages || []).reduce(
    (buttonComps: any, page: { components: any }) =>
      buttonComps.concat(
        (page.components || []).filter(
          (c: { type: string }) => c.type === 'OptionButtons' || c.type === 'OptionSelector'
        )
      ),
    []
  )

  buttonComps.forEach(
    (c: { key: string | number }) =>
      (displayValues[c.key] = replaceWithDisplayValues(
        displayValues[c.key],
        getButtons(c, userData) || []
      ))
  )

  return displayValues
}
function replaceWithDisplayValues(v: string[] | string, buttons: any[]) {
  if (Array.isArray(v))
    return v.map((val) => (buttons.find((b: { key: string }) => b.key === val) || {}).text || val)

  return (buttons.find((b: { key: string }) => b.key === v) || {}).text || v
}
